<script>
    import VueContentLoading from 'vue-content-loading';

    export default {
        components: {
            VueContentLoading,
        },
    };
</script>

<template>
    <vue-content-loading :height="330">
        <rect x="75" y="15" rx="10" ry="10" width="250" height="250" />
    </vue-content-loading>
</template>
